import http from './httpInstance'

// 请求皮肤主题
function getTheme () {
  return http({
    method: 'get',
    url: '/artemis-portal/artemis/theme'
  })
}

function getUserInfo () {
  return http({
    method: 'get',
    url: 'https://my-json-server.typicode.com/zimplexing/demo/userInfo'
  })
}

// 请求菜单列表
function getMenuList () {
  return http({
    method: 'get',
    url: '/artemis-portal/artemis/menuList'
  })
}

// 请求项目信息
function getProjectInfo (lan) {
  return http({
    method: 'get',
    url: `/artemis-portal/artemis/projectInfo?lan=${lan}`
  })
}

// 请求下载页文档列表
function getDownloadCategory () {
  return http({
    method: 'post',
    url: '/artemis-portal/artemis/service/rs/v3/download/category/search/condition',
    data: {
      pageNo: 1,
      pageSize: 10000
    }
  })
}

function getDownloadFiles (ids) {
  return http({
    method: 'post',
    url: '/artemis-portal/artemis/service/rs/v3/download/category/search/id',
    data: ids
  })
}

// 获取目录树
function getTree (data) {
  return http({
    method: 'post',
    url: '/artemis-portal/artemis/service/rs/v3/document/tree',
    data
  })
}

// 根据文档Id查询文档信息
function getDocById (data) {
  return http({
    method: 'post',
    url: '/artemis-portal/artemis/service/rs/v3/document/search/id',
    data
  })
}

// 根据分组id/name查询API
function getApiByGroupId (data) {
  return http({
    method: 'post',
    url: `/artemis-portal/artemis/service/rs/v3/api/search/condition`,
    data
  })
}

// 根据分组id/name查询API
function getDocByName (data) {
  return http({
    method: 'post',
    url: `/artemis-portal/artemis/service/rs/v3/document/search/tree`,
    data
  })
}

// 根据文档关联API分组Id查询文档信息
function getDocByGroupId (data) {
  return http({
    method: 'post',
    url: `/artemis-portal/artemis/service/rs/v3/document/search/relatedGroupId`,
    data
  })
}

// 根据请求来源获取真实api请求path
function getApiHost () {
  return http({
    method: 'post',
    url: `/artemis-portal/artemis/service/rs/v3/document/apiHostInfo`,
    data: {}
  })
}

// 获取分组描述
function getGroup (data) {
  return http({
    method: 'post',
    url: `/artemis-portal/artemis/service/rs/v3/group/search/id`,
    data
  })
}

function getGroupList (data) {
  return http({
    method: 'post',
    url: `/artemis-portal/artemis/service/rs/v3/group/search/ids`,
    data
  })
}

// 获取所有接口的汇总文档
function getAllApiDoc() {
  return http({
    method: 'get',
    url: `/artemis-portal/artemis/getAllApiDoc`,
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
  })
}

//获取产品名称和版本信息接口
  function getProductIdAndVersion () {
    return http({
      method: 'get',
      url: `/artemis-portal/artemis/getProductIdAndVersion`
    })
  }


function getApiGroupDoc (data) {
  return http({
    method: 'get',
    url: `/artemis-portal/artemis/getApiGroupDoc/${data}`,
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
  })
}

function getSdkByApiGroup(data) {
  return http({
    method: 'get',
    url: `/artemis-portal/artemis/getSdkByApiGroupPId?id=${data}`,
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
  })
}

function getSceneGroup (data) {
  return http({
    method: 'post',
    url: `/artemis-portal/artemis/service/rs/v1/ability/search/group`,
    data
  })
}

function getSceneById (data) {
  return http({
    method: 'post',
    url: `/artemis-portal/artemis/service/rs/v1/ability/search/id`,
    data
  })
}

function searchSceneList (data) {
  return http({
    method: 'post',
    url: `/artemis-portal/artemis/service/rs/v1/ability/search/condition`,
    data
  })
}

function getDisplayConfig () {
  return http({
    method: 'get',
    url: `/artemis-portal/artemis/service/rs/v1/ability/search/display/config`
  })
}

function getApiInfoByIds (data) {
  return http({
    method: 'post',
    url: `/artemis-portal/artemis/service/rs/v3/api/search/ids`,
    data
  })
}

function getApiIdsByAIdAndGroupId (aId, gId) {
  return http({
    method: 'get',
    url: `/artemis-portal/artemis/service/rs/v1/ability/search/apiIds?aId=${aId}&groupId=${gId}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
  })
}

function getSceneInfoByGroupId (data) {
  return http({
    method: 'post',
    url: `/artemis-portal/artemis/service/rs/v1/ability/search/byGroupId`,
    data
  })
}

function getAbilitResourceList (data) {
  return http({
    method: 'post',
    url: `/artemis-portal/artemis/service/rs/v1/ability/search/resourceList`,
    data
  })
}

export {
  getTheme,
  getUserInfo,
  getMenuList,
  getProjectInfo,
  getDownloadCategory,
  getDownloadFiles,
  getTree,
  getDocById,
  getGroupList,
  getApiByGroupId,
  getDocByName,
  getApiHost,
  getDocByGroupId,
  getGroup,
  getAllApiDoc,
  getProductIdAndVersion,
  getApiGroupDoc,
  getSdkByApiGroup,
  getSceneById,
  getApiInfoByIds,
  getSceneGroup,
  getDisplayConfig,
  searchSceneList,
  getSceneInfoByGroupId,
  getAbilitResourceList,
  getApiIdsByAIdAndGroupId,

}
